module.exports = __webpack_public_path__ + "static/media/pin.ea1a5dd5.svg";